import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import axios from 'axios';
import animations from './animations';
import FancyInput from "../../elements/FancyInput";
import Button from "../../elements/Button";
import HoneyPot from "../../elements/HoneyPot";
import globals from "../../globals";
import FancySelect from "../../elements/FancySelect/FancySelect";
import Errors from "../../elements/Errors";
import Success from "../../elements/Success";
import { sha256 } from 'js-sha256';

const TYPE_SALES = 'Corporate Sales';
const TYPE_SMB_SALES = 'Small Business Sales';
const TYPE_SUPPORT = 'Corporate Support';
const TYPE_PROVISIONING = 'Corporate Provisioning';
const TYPE_BILLING = 'Corporate Billing';

const types = [
	// TYPE_SALES,
	// TYPE_SMB_SALES,
	// TYPE_SUPPORT,
	// TYPE_PROVISIONING,
	// TYPE_BILLING
	// todo: Remove these
	'Small business nbn&trade;',
	'Other business services'
];

class SlideForm extends Component {

    constructor(props) {
        super(props);

        this.honeypot = 'dob';

        this.state = {
			first_name: globals.getSessionVar('first_name'),
			last_name: globals.getSessionVar('last_name'),
			company: globals.getSessionVar('company'),
			email: globals.getSessionVar('email'),
			mobile: globals.getSessionVar('phone'), //todo: Uniform field names
            enquiring_about: '',
            description: '',
            [this.honeypot]: '',
            errors: [],
			animateSuccess: false
        };
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        });
    }

    handleSelectChange(value) {
        this.setState({
            enquiring_about: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.reset();
        animations.showLoader(this);

        setTimeout(() => {
            axios.post('/api/submit-contact-form', this.state)
                .then(() => {
                    globals.pushEvent('contactFormSubmit');
                    globals.pushHJEvent('/contactFormSubmit');
                    globals.pushGA4Events('contactFormSubmissionBusiness',
                        {
                            eventInfo: {
                                formName: 'Get in touch',
                                hashedFirstName: sha256(this.state.first_name),
                                hashedLastName: sha256(this.state.last_name),
                                hashedEmail: sha256(this.state.email),
                                hashedPhoneNumber: sha256(this.state.mobile),
                                enquiryType: this.state.enquiring_about,
                                pageCategory: 'Business',
                            }
                        })
                    this.showSuccess();
                })
                .catch(response => {
                    this.reset();
                    if (response.response.status === 422) {
                        this.processValidation(response.response);
                    } else {
                        this.handleError(response);
                    }
                });
        }, 2000);
    }

    showSuccess() {
		this.setState({
			animateSuccess: true
		}, () => {
			animations.hideLoader(this);
			this.resetForm();
		});
	}

    resetForm() {
        this.setState({
            first_name: '',
            last_name: '',
            mobile: '',
            company: '',
            email: '',
            description: ''
        });

        findDOMNode(this).querySelectorAll('.input--filled').forEach(value => {
            value.classList.remove('input--filled');
        });
    }

    processValidation(response) {
        let SlideFormNode = findDOMNode(this),
            errors = response.data.errors;

            for (let key in errors) {
                if (key === this.honeypot) {
                    // do nothing
                } else if (key === 'description') {
                    SlideFormNode.getElementsByClassName('input-enquiry')[0].style.borderColor = 'red';
                } else if (key === 'enquiring_about') {
                    SlideFormNode.querySelector('.fancy-select .label').style.borderColor = 'red';
                } else {
                    SlideFormNode.querySelector('.input-' + key + ' .graphic--nao').style.stroke = 'red';
                }

                this.updateErrors(errors[key][0]);
            }

            animations.showErrors(this);
    }

    updateErrors(newError) {
        this.setState(prevState => ({
            errors: [...prevState.errors, newError]
        }));
    }

    handleError(response) {
        this.updateErrors(globals.getGenericErrorMsg());
        animations.showErrors(this);
        globals.handleError(response.message, response);
    }

    reset() {
        this.setState({
            errors: [],
			animateSuccess: false
        });
        animations.reset(this);
    }

    render() {
        return (
            <div>
                <div className="row form-row">
                    <div className="col-xs-12">
                        <form onSubmit={this.handleSubmit.bind(this)}>
                            <div className="row row-1">
                                <div className="col-sm-4">
                                    <FancyInput name="first_name" maxLength="50" label="First Name" value={this.state.first_name} handleChange={this.handleInputChange.bind(this)} />
                                </div>
                                <div className="col-sm-4">
                                    <FancyInput name="last_name" maxLength="50" label="Last Name" value={this.state.last_name} handleChange={this.handleInputChange.bind(this)} />
                                </div>
                                <div className="col-sm-4">
                                    <FancyInput name="mobile" type="tel" maxLength="20" label="Mobile Number" value={this.state.mobile} handleChange={this.handleInputChange.bind(this)} />
                                </div>
                            </div>

                            <HoneyPot nameField={this.honeypot} nameValue={this.state[this.honeypot]} handleChange={this.handleInputChange.bind(this)} />

                            <div className="row row-2">
                                <div className="col-sm-4">
                                    <FancyInput name="company" maxLength="50" label="Company (optional)" value={this.state.company} handleChange={this.handleInputChange.bind(this)} />
                                </div>
                                <div className="col-sm-4">
                                    <FancyInput name="email" type="email" maxLength="50" label="Email" value={this.state.email} handleChange={this.handleInputChange.bind(this)} />
                                </div>
                                <div className="col-sm-4">
                                    <FancySelect
                                        title="I'm enquiring about:"
                                        theme="white"
                                        list={types}
                                        setValue={this.handleSelectChange.bind(this)}
                                    />
                                </div>
                            </div>
                            <div className="row row-3">
                                <div className="col-sm-12">
                                    <textarea placeholder="How can we help you?" name="description" maxLength="1000" className="input-enquiry input-label-styled" value={this.state.description} onChange={this.handleInputChange.bind(this)} />
                                </div>
                            </div>
							<Errors errors={this.state.errors} />
                            <div className="row centered">
                                <div className="col-xs-12">
                                    <Button
                                        action={event => this.handleSubmit(event)}
                                        image="/images/btn-submit.svg"
                                        alt="Lets get started"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <Success animate={this.state.animateSuccess} />
                <div className="loader">
                    <img src="/images/loader-anim-mobile.svg" alt="loading..." className="not-ie" />
                    <img src="/images/loader-anim-ie.gif" alt="Loading..." className="ie" />
                </div>
            </div>
        );
    }

}

export default SlideForm;


// WEBPACK FOOTER //
// ./resources/assets/js/forms/SlideForm/SlideForm.js